export default "__VITE_ASSET__0abb56ce__"